export const successId = {
  pageTitle: 'successPageTitle',
};
